namespace RioERP.Invoices {
    export interface InvoiceOrdersForm {
        OrderId: Serenity.LookupEditor;
    }

    export class InvoiceOrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.InvoiceOrders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceOrdersForm.init)  {
                InvoiceOrdersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(InvoiceOrdersForm, [
                    'OrderId', w0
                ]);
            }
        }
    }
}
